import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/jobRequests'
import Component from 'components/JobRequests'

export default createListViewContainer({ actions, selectors: selectors.jobRequests })(Component)
